import React, { useState } from "react";
import Select from "react-select";

const EditDepartmentDropdown = ({
  departments,
  selectedDepartmentId,
  handleChange,
  value,
}) => {
    const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: 100,
      overflowY: "auto",
      zIndex: 9999, // Ensure it's on top of other elements
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 100,
      overflowY: "auto",
      zIndex: 9999, // Ensure it's on top of other elements
    }),
  };
  const [department, setDepartment] = useState(value);
  const departmentOptions = departments
    .filter((dep) => dep.isActive)
    .map((department) => ({
      value: department?._id,
      label: department?.name,
    }));

  const handleDepartmentChange = (selectedOption) => {
    setDepartment({
      name: "departmentId",
      label: selectedOption ? selectedOption.label : "",
      value: selectedOption ? selectedOption.value : "",
    });
    handleChange({
      name: "departmentId",
      label: selectedOption ? selectedOption.label : "",
      value: selectedOption ? selectedOption.value : "",
    });
  };
  return (
    <div className="form-group">
      <label className="mb-1">
        Department<span className="star-mark"> *</span>
      </label>
      <Select
        name="departmentId"
        value={department}
        onChange={handleDepartmentChange}
        options={departmentOptions}
        placeholder="Select Department"
         styles={customStyles}
      />
    </div>
  );
};
export default EditDepartmentDropdown;
